import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { RemoveCircleOutlined as DeleteIcon } from '@mui/icons-material';
import { useAuth0 } from '@auth0/auth0-react';

import AssessmentMethods from './components/AssessmentMethods';
import AssessmentVisuals from './components/AssessmentVisuals';
import { useTreatmentPlanEditable } from '../../../hooks/useTreatmentPlanEditable';
import { FHButton } from '../../../../../base';
import { FORTA_WHITE } from '../../../../../../utils/colors';
import { Themes } from '../../../../../../constants';
import { assessmentActions } from '../../../../../../store';

import type { IAssessmentTool } from '../../../../../../utils/types';

interface AssessmentProps {
  assessmentTool?: IAssessmentTool;
  onRemove?: () => void;
}

function AssessmentTool({ assessmentTool, onRemove }: AssessmentProps) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const editable = useTreatmentPlanEditable();

  const { current: treatmentPlan } = useSelector((state: any) => state.treatmentPlans);
  const { assessment } = useSelector((state: any) => state.assessments);

  const planId = treatmentPlan?.id;

  const handleDeleteAssessmentTools = () => {
    if (!assessmentTool?.id && onRemove) {
      onRemove();
      return;
    }

    if (!planId || !assessmentTool?.id || !assessment?.id) return;
    dispatch(
      assessmentActions.deleteTool({
        getAccessTokenSilently,
        planId,
        assessmentId: assessment.id,
        toolId: assessmentTool.id,
      }),
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <AssessmentMethods assessmentTool={assessmentTool} />
        <AssessmentVisuals assessmentTool={assessmentTool} />
      </Box>
      {editable && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <FHButton
            sx={{ mt: assessmentTool?.id ? -5 : 3, mb: 1 }}
            colorTheme={Themes.Primary}
            onClick={handleDeleteAssessmentTools}
            startIcon={<DeleteIcon data-testid="deleteAssesment" sx={{ color: FORTA_WHITE }} />}
          >
            Delete Assessment
          </FHButton>
        </Box>
      )}
    </Box>
  );
}

export default AssessmentTool;
